import React from "react";
import { SvgIconProps } from "@mui/material/SvgIcon";

import { Icon } from "merchant-portal-common/Icon";

function ErrorIcon(props: SvgIconProps) {
	const paths = [
		{
			d: "M34.9982 0C32.2753 0 29.5522 1.33354 28.0802 4.00301L0.962177 53.204C-1.89778 58.3936 1.97429 65 7.88026 65H62.1198C68.0257 65 71.8978 58.3936 69.0378 53.204L41.9164 4.00301C40.4444 1.33354 37.7213 0 34.9982 0ZM34.9982 5.09569C35.8892 5.09569 36.779 5.58199 37.3181 6.55945L64.4395 55.7603C65.479 57.6466 64.2613 59.7222 62.1198 59.7222H7.88026C5.73863 59.7222 4.52108 57.6466 5.56054 55.7603L32.6785 6.55945C33.2175 5.58199 34.1074 5.09569 34.9982 5.09569ZM34.9572 19.2213C34.2609 19.2322 33.5975 19.5204 33.1124 20.0221C32.6274 20.524 32.3606 21.1987 32.3706 21.898V39.4907C32.3657 39.8404 32.4301 40.1875 32.5599 40.5121C32.6897 40.8365 32.8824 41.1319 33.127 41.381C33.3715 41.6299 33.6628 41.8277 33.9841 41.9626C34.3054 42.0977 34.6501 42.1672 34.9982 42.1672C35.3465 42.1672 35.6912 42.0977 36.0125 41.9626C36.3337 41.8277 36.6251 41.6299 36.8696 41.381C37.1142 41.1319 37.3068 40.8365 37.4367 40.5121C37.5665 40.1875 37.6309 39.8404 37.6258 39.4907V21.898C37.6309 21.5448 37.5654 21.1942 37.433 20.8669C37.3005 20.5397 37.1042 20.2424 36.8552 19.9927C36.6065 19.7431 36.3103 19.5462 35.9841 19.4138C35.6581 19.2813 35.309 19.2159 34.9572 19.2213ZM34.9982 47.4074C34.0691 47.4074 33.178 47.778 32.5209 48.4379C31.864 49.0978 31.4947 49.9928 31.4947 50.9259C31.4947 51.859 31.864 52.7539 32.5209 53.4138C33.178 54.0737 34.0691 54.4444 34.9982 54.4444C35.9275 54.4444 36.8186 54.0737 37.4757 53.4138C38.1326 52.7539 38.5017 51.859 38.5017 50.9259C38.5017 49.9928 38.1326 49.0978 37.4757 48.4379C36.8186 47.778 35.9275 47.4074 34.9982 47.4074Z",
		},
	];

	return (
		<Icon
			dataTestId="error-icon"
			width={70}
			height={65}
			viewBox="0 0 70 65"
			paths={paths}
			{...props}
		/>
	);
}

export default ErrorIcon;
